import { Outlet, useLocation, useNavigate } from "react-router-dom";
import ContainerNavigation from "../../components/ContainerNavigation";
import { useNavigationBar } from "../../context/NavigationContext";

const UserFeedbackLayout = () => {
  const navContext = useNavigationBar();
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as { backgroundLocation?: Location };

  // const { showModal, confirmNavigation, cancelNavigation } = usePrompt("Are you sure you want to leave this page?", true);
  const {
    backArrow,
    title,
    subtitle,
    buttonTitle,
    enableLink,
    onBack,
    onClose,
    FilterButton,
    icon,
    onFilter,
    onNext,
    getActionItems,
    onActionItemSelect,
  } = navContext.navProps;

  // useEffect(() => {
  //   if (blocker.state === "blocked") {
  //     blocker.reset();
  //   }
  // }, [blocker]);

  return (
    <div className="container-modal">
      <div className="relative container-modal-content">
        <div>
          <ContainerNavigation
            backArrow={backArrow}
            title={title}
            subtitle={subtitle}
            icon={icon}
            enableLink={enableLink}
            buttonTitle={buttonTitle}
            onBack={onBack}
            onClose={onClose}
            // FilterButton={FilterButton}
            onFilter={onFilter}
            getActionItems={getActionItems}
            onActionItemSelect={onActionItemSelect}
          />

          <div className="left-0 flex flex-col w-full h-[calc(100vh-200px)] overflow-y-auto top-[84px] ">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserFeedbackLayout;
